import React from "react";
import { StyleSheet, View } from "react-native";
import { Typography, Input, Button } from "src/components";
import { InputProps } from "src/components/input";
import { colors } from "src/assets";
import LocalText from "src/local";

export type Props = {
  onClose: () => void;
} & InputProps;

const Index: React.FC<Props> = ({ onClose, ...props }) => {
  return (
    <View style={styles.container}>
      <View style={styles.label}>
        <Typography
          variant={"h1"}
          text={LocalText.screens.home.searchBar.search}
        />
        <Button
          variant={"icon"}
          icon={"cross"}
          iconSize={14}
          iconColor={colors.chokuGray3}
          onPress={onClose}
        />
      </View>
      <Input
        variant={"search"}
        placeholder={LocalText.screens.home.searchBar.placeholder}
        style={styles.input}
        {...props}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    backgroundColor: colors.gray1,
    padding: 16,
  },
  label: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  input: {
    flex: 1,
    margin: 0,
    padding: 0,
    outlineStyle: "none",
  },
});

export default Index;
